// extracted by mini-css-extract-plugin
export default {"count":"pe5li","root":"Yovwu","container":"Z7zV8","disclaimer":"lgRoA"};